import styled from "styled-components";

export const StyledAccountPopupContainer = styled.div`
  width: 280px;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  padding: 16px 0;
  display: flex;
  flex-direction: column;
`;

export const StyledUserInfoSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 16px 16px;
`;

export const StyledProfileAvatar = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #1249bf;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 600;
  flex-shrink: 0;
`;

export const StyledUserDetails = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .name {
    font-size: 14px;
    font-weight: 600;
    color: #0e0e2c;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .email {
    font-size: 12px;
    color: #686978;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const StyledSeparator = styled.div`
  height: 1px;
  background-color: #e4e4e4;
  width: 100%;
`;

export const StyledActionList = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px 0 0;

  .action-item {
    padding: 10px 16px;
    font-size: 14px;
    color: #4a4a68;
    cursor: pointer;
    transition: background-color 0.2s ease;
    border: transparent;
    background: transparent;
    text-align: left;

    &:hover {
      background-color: #f7f8f9;
      color: #1249bf;
    }
  }
`;
